export enum TransferMethodType {
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  WIRE_ACCOUNT = 'WIRE_ACCOUNT',
  BANK_CARD = 'BANK_CARD',
  PAYPAL_ACCOUNT = 'PAYPAL_ACCOUNT',
  VENMO_ACCOUNT = 'VENMO_ACCOUNT'
}

export interface TransferMethodDetails {
  transferMethodType: TransferMethodType;
  accountId?: string;
  bankAccountId?: string;
  cardBrand?: string;
  cardNumber?: string;
  dateOfExpiry?: string;
  email?: string;
}
